// Country codes service with comprehensive list of countries and their phone codes
export class CountryCodeService {
  static getCountryCodes() {
    return [
      { value: '+1', label: '+1 (US)', country: 'United States' },
      { value: '+1', label: '+1 (CA)', country: 'Canada' },
      { value: '+7', label: '+7 (RU)', country: 'Russia' },
      { value: '+20', label: '+20 (EG)', country: 'Egypt' },
      { value: '+27', label: '+27 (ZA)', country: 'South Africa' },
      { value: '+30', label: '+30 (GR)', country: 'Greece' },
      { value: '+31', label: '+31 (NL)', country: 'Netherlands' },
      { value: '+32', label: '+32 (BE)', country: 'Belgium' },
      { value: '+33', label: '+33 (FR)', country: 'France' },
      { value: '+34', label: '+34 (ES)', country: 'Spain' },
      { value: '+36', label: '+36 (HU)', country: 'Hungary' },
      { value: '+39', label: '+39 (IT)', country: 'Italy' },
      { value: '+40', label: '+40 (RO)', country: 'Romania' },
      { value: '+41', label: '+41 (CH)', country: 'Switzerland' },
      { value: '+43', label: '+43 (AT)', country: 'Austria' },
      { value: '+44', label: '+44 (GB)', country: 'United Kingdom' },
      { value: '+45', label: '+45 (DK)', country: 'Denmark' },
      { value: '+46', label: '+46 (SE)', country: 'Sweden' },
      { value: '+47', label: '+47 (NO)', country: 'Norway' },
      { value: '+48', label: '+48 (PL)', country: 'Poland' },
      { value: '+49', label: '+49 (DE)', country: 'Germany' },
      { value: '+51', label: '+51 (PE)', country: 'Peru' },
      { value: '+52', label: '+52 (MX)', country: 'Mexico' },
      { value: '+53', label: '+53 (CU)', country: 'Cuba' },
      { value: '+54', label: '+54 (AR)', country: 'Argentina' },
      { value: '+55', label: '+55 (BR)', country: 'Brazil' },
      { value: '+56', label: '+56 (CL)', country: 'Chile' },
      { value: '+57', label: '+57 (CO)', country: 'Colombia' },
      { value: '+58', label: '+58 (VE)', country: 'Venezuela' },
      { value: '+60', label: '+60 (MY)', country: 'Malaysia' },
      { value: '+61', label: '+61 (AU)', country: 'Australia' },
      { value: '+62', label: '+62 (ID)', country: 'Indonesia' },
      { value: '+63', label: '+63 (PH)', country: 'Philippines' },
      { value: '+64', label: '+64 (NZ)', country: 'New Zealand' },
      { value: '+65', label: '+65 (SG)', country: 'Singapore' },
      { value: '+66', label: '+66 (TH)', country: 'Thailand' },
      { value: '+81', label: '+81 (JP)', country: 'Japan' },
      { value: '+82', label: '+82 (KR)', country: 'South Korea' },
      { value: '+84', label: '+84 (VN)', country: 'Vietnam' },
      { value: '+86', label: '+86 (CN)', country: 'China' },
      { value: '+90', label: '+90 (TR)', country: 'Turkey' },
      { value: '+91', label: '+91 (IN)', country: 'India' },
      { value: '+92', label: '+92 (PK)', country: 'Pakistan' },
      { value: '+93', label: '+93 (AF)', country: 'Afghanistan' },
      { value: '+94', label: '+94 (LK)', country: 'Sri Lanka' },
      { value: '+95', label: '+95 (MM)', country: 'Myanmar' },
      { value: '+98', label: '+98 (IR)', country: 'Iran' },
      { value: '+212', label: '+212 (MA)', country: 'Morocco' },
      { value: '+213', label: '+213 (DZ)', country: 'Algeria' },
      { value: '+216', label: '+216 (TN)', country: 'Tunisia' },
      { value: '+218', label: '+218 (LY)', country: 'Libya' },
      { value: '+220', label: '+220 (GM)', country: 'Gambia' },
      { value: '+221', label: '+221 (SN)', country: 'Senegal' },
      { value: '+222', label: '+222 (MR)', country: 'Mauritania' },
      { value: '+223', label: '+223 (ML)', country: 'Mali' },
      { value: '+224', label: '+224 (GN)', country: 'Guinea' },
      { value: '+225', label: '+225 (CI)', country: 'Ivory Coast' },
      { value: '+226', label: '+226 (BF)', country: 'Burkina Faso' },
      { value: '+227', label: '+227 (NE)', country: 'Niger' },
      { value: '+228', label: '+228 (TG)', country: 'Togo' },
      { value: '+229', label: '+229 (BJ)', country: 'Benin' },
      { value: '+230', label: '+230 (MU)', country: 'Mauritius' },
      { value: '+231', label: '+231 (LR)', country: 'Liberia' },
      { value: '+232', label: '+232 (SL)', country: 'Sierra Leone' },
      { value: '+233', label: '+233 (GH)', country: 'Ghana' },
      { value: '+234', label: '+234 (NG)', country: 'Nigeria' },
      { value: '+235', label: '+235 (TD)', country: 'Chad' },
      { value: '+236', label: '+236 (CF)', country: 'Central African Republic' },
      { value: '+237', label: '+237 (CM)', country: 'Cameroon' },
      { value: '+238', label: '+238 (CV)', country: 'Cape Verde' },
      { value: '+239', label: '+239 (ST)', country: 'Sao Tome and Principe' },
      { value: '+240', label: '+240 (GQ)', country: 'Equatorial Guinea' },
      { value: '+241', label: '+241 (GA)', country: 'Gabon' },
      { value: '+242', label: '+242 (CG)', country: 'Republic of the Congo' },
      { value: '+243', label: '+243 (CD)', country: 'Democratic Republic of the Congo' },
      { value: '+244', label: '+244 (AO)', country: 'Angola' },
      { value: '+245', label: '+245 (GW)', country: 'Guinea-Bissau' },
      { value: '+246', label: '+246 (IO)', country: 'British Indian Ocean Territory' },
      { value: '+248', label: '+248 (SC)', country: 'Seychelles' },
      { value: '+249', label: '+249 (SD)', country: 'Sudan' },
      { value: '+250', label: '+250 (RW)', country: 'Rwanda' },
      { value: '+251', label: '+251 (ET)', country: 'Ethiopia' },
      { value: '+252', label: '+252 (SO)', country: 'Somalia' },
      { value: '+253', label: '+253 (DJ)', country: 'Djibouti' },
      { value: '+254', label: '+254 (KE)', country: 'Kenya' },
      { value: '+255', label: '+255 (TZ)', country: 'Tanzania' },
      { value: '+256', label: '+256 (UG)', country: 'Uganda' },
      { value: '+257', label: '+257 (BI)', country: 'Burundi' },
      { value: '+258', label: '+258 (MZ)', country: 'Mozambique' },
      { value: '+260', label: '+260 (ZM)', country: 'Zambia' },
      { value: '+261', label: '+261 (MG)', country: 'Madagascar' },
      { value: '+262', label: '+262 (RE)', country: 'Reunion' },
      { value: '+263', label: '+263 (ZW)', country: 'Zimbabwe' },
      { value: '+264', label: '+264 (NA)', country: 'Namibia' },
      { value: '+265', label: '+265 (MW)', country: 'Malawi' },
      { value: '+266', label: '+266 (LS)', country: 'Lesotho' },
      { value: '+267', label: '+267 (BW)', country: 'Botswana' },
      { value: '+268', label: '+268 (SZ)', country: 'Eswatini' },
      { value: '+269', label: '+269 (KM)', country: 'Comoros' },
      { value: '+290', label: '+290 (SH)', country: 'Saint Helena' },
      { value: '+291', label: '+291 (ER)', country: 'Eritrea' },
      { value: '+297', label: '+297 (AW)', country: 'Aruba' },
      { value: '+298', label: '+298 (FO)', country: 'Faroe Islands' },
      { value: '+299', label: '+299 (GL)', country: 'Greenland' },
      { value: '+350', label: '+350 (GI)', country: 'Gibraltar' },
      { value: '+351', label: '+351 (PT)', country: 'Portugal' },
      { value: '+352', label: '+352 (LU)', country: 'Luxembourg' },
      { value: '+353', label: '+353 (IE)', country: 'Ireland' },
      { value: '+354', label: '+354 (IS)', country: 'Iceland' },
      { value: '+355', label: '+355 (AL)', country: 'Albania' },
      { value: '+356', label: '+356 (MT)', country: 'Malta' },
      { value: '+357', label: '+357 (CY)', country: 'Cyprus' },
      { value: '+358', label: '+358 (FI)', country: 'Finland' },
      { value: '+359', label: '+359 (BG)', country: 'Bulgaria' },
      { value: '+370', label: '+370 (LT)', country: 'Lithuania' },
      { value: '+371', label: '+371 (LV)', country: 'Latvia' },
      { value: '+372', label: '+372 (EE)', country: 'Estonia' },
      { value: '+373', label: '+373 (MD)', country: 'Moldova' },
      { value: '+374', label: '+374 (AM)', country: 'Armenia' },
      { value: '+375', label: '+375 (BY)', country: 'Belarus' },
      { value: '+376', label: '+376 (AD)', country: 'Andorra' },
      { value: '+377', label: '+377 (MC)', country: 'Monaco' },
      { value: '+378', label: '+378 (SM)', country: 'San Marino' },
      { value: '+380', label: '+380 (UA)', country: 'Ukraine' },
      { value: '+381', label: '+381 (RS)', country: 'Serbia' },
      { value: '+382', label: '+382 (ME)', country: 'Montenegro' },
      { value: '+383', label: '+383 (XK)', country: 'Kosovo' },
      { value: '+385', label: '+385 (HR)', country: 'Croatia' },
      { value: '+386', label: '+386 (SI)', country: 'Slovenia' },
      { value: '+387', label: '+387 (BA)', country: 'Bosnia and Herzegovina' },
      { value: '+389', label: '+389 (MK)', country: 'North Macedonia' },
      { value: '+420', label: '+420 (CZ)', country: 'Czech Republic' },
      { value: '+421', label: '+421 (SK)', country: 'Slovakia' },
      { value: '+423', label: '+423 (LI)', country: 'Liechtenstein' },
      { value: '+500', label: '+500 (FK)', country: 'Falkland Islands' },
      { value: '+501', label: '+501 (BZ)', country: 'Belize' },
      { value: '+502', label: '+502 (GT)', country: 'Guatemala' },
      { value: '+503', label: '+503 (SV)', country: 'El Salvador' },
      { value: '+504', label: '+504 (HN)', country: 'Honduras' },
      { value: '+505', label: '+505 (NI)', country: 'Nicaragua' },
      { value: '+506', label: '+506 (CR)', country: 'Costa Rica' },
      { value: '+507', label: '+507 (PA)', country: 'Panama' },
      { value: '+508', label: '+508 (PM)', country: 'Saint Pierre and Miquelon' },
      { value: '+509', label: '+509 (HT)', country: 'Haiti' },
      { value: '+590', label: '+590 (GP)', country: 'Guadeloupe' },
      { value: '+591', label: '+591 (BO)', country: 'Bolivia' },
      { value: '+592', label: '+592 (GY)', country: 'Guyana' },
      { value: '+593', label: '+593 (EC)', country: 'Ecuador' },
      { value: '+594', label: '+594 (GF)', country: 'French Guiana' },
      { value: '+595', label: '+595 (PY)', country: 'Paraguay' },
      { value: '+596', label: '+596 (MQ)', country: 'Martinique' },
      { value: '+597', label: '+597 (SR)', country: 'Suriname' },
      { value: '+598', label: '+598 (UY)', country: 'Uruguay' },
      { value: '+599', label: '+599 (CW)', country: 'Curacao' },
      { value: '+670', label: '+670 (TL)', country: 'East Timor' },
      { value: '+672', label: '+672 (NF)', country: 'Norfolk Island' },
      { value: '+673', label: '+673 (BN)', country: 'Brunei' },
      { value: '+674', label: '+674 (NR)', country: 'Nauru' },
      { value: '+675', label: '+675 (PG)', country: 'Papua New Guinea' },
      { value: '+676', label: '+676 (TO)', country: 'Tonga' },
      { value: '+677', label: '+677 (SB)', country: 'Solomon Islands' },
      { value: '+678', label: '+678 (VU)', country: 'Vanuatu' },
      { value: '+679', label: '+679 (FJ)', country: 'Fiji' },
      { value: '+680', label: '+680 (PW)', country: 'Palau' },
      { value: '+681', label: '+681 (WF)', country: 'Wallis and Futuna' },
      { value: '+682', label: '+682 (CK)', country: 'Cook Islands' },
      { value: '+683', label: '+683 (NU)', country: 'Niue' },
      { value: '+684', label: '+684 (AS)', country: 'American Samoa' },
      { value: '+685', label: '+685 (WS)', country: 'Samoa' },
      { value: '+686', label: '+686 (KI)', country: 'Kiribati' },
      { value: '+687', label: '+687 (NC)', country: 'New Caledonia' },
      { value: '+688', label: '+688 (TV)', country: 'Tuvalu' },
      { value: '+689', label: '+689 (PF)', country: 'French Polynesia' },
      { value: '+690', label: '+690 (TK)', country: 'Tokelau' },
      { value: '+691', label: '+691 (FM)', country: 'Micronesia' },
      { value: '+692', label: '+692 (MH)', country: 'Marshall Islands' },
      { value: '+850', label: '+850 (KP)', country: 'North Korea' },
      { value: '+852', label: '+852 (HK)', country: 'Hong Kong' },
      { value: '+853', label: '+853 (MO)', country: 'Macau' },
      { value: '+855', label: '+855 (KH)', country: 'Cambodia' },
      { value: '+856', label: '+856 (LA)', country: 'Laos' },
      { value: '+880', label: '+880 (BD)', country: 'Bangladesh' },
      { value: '+886', label: '+886 (TW)', country: 'Taiwan' },
      { value: '+960', label: '+960 (MV)', country: 'Maldives' },
      { value: '+961', label: '+961 (LB)', country: 'Lebanon' },
      { value: '+962', label: '+962 (JO)', country: 'Jordan' },
      { value: '+963', label: '+963 (SY)', country: 'Syria' },
      { value: '+964', label: '+964 (IQ)', country: 'Iraq' },
      { value: '+965', label: '+965 (KW)', country: 'Kuwait' },
      { value: '+966', label: '+966 (SA)', country: 'Saudi Arabia' },
      { value: '+967', label: '+967 (YE)', country: 'Yemen' },
      { value: '+968', label: '+968 (OM)', country: 'Oman' },
      { value: '+970', label: '+970 (PS)', country: 'Palestine' },
      { value: '+971', label: '+971 (AE)', country: 'United Arab Emirates' },
      { value: '+972', label: '+972 (IL)', country: 'Israel' },
      { value: '+973', label: '+973 (BH)', country: 'Bahrain' },
      { value: '+974', label: '+974 (QA)', country: 'Qatar' },
      { value: '+975', label: '+975 (BT)', country: 'Bhutan' },
      { value: '+976', label: '+976 (MN)', country: 'Mongolia' },
      { value: '+977', label: '+977 (NP)', country: 'Nepal' },
      { value: '+992', label: '+992 (TJ)', country: 'Tajikistan' },
      { value: '+993', label: '+993 (TM)', country: 'Turkmenistan' },
      { value: '+994', label: '+994 (AZ)', country: 'Azerbaijan' },
      { value: '+995', label: '+995 (GE)', country: 'Georgia' },
      { value: '+996', label: '+996 (KG)', country: 'Kyrgyzstan' },
      { value: '+998', label: '+998 (UZ)', country: 'Uzbekistan' }
    ];
  }
  
  static getCountryCodeOptions() {
    return this.getCountryCodes().map(country => ({
      value: country.value,
      label: country.label
    }));
  }
  
  static findCountryByCode(code) {
    return this.getCountryCodes().find(country => country.value === code);
  }
  
  static searchCountryCodes(searchTerm) {
    const term = searchTerm.toLowerCase();
    return this.getCountryCodes().filter(country => 
      country.label.toLowerCase().includes(term) ||
      country.country.toLowerCase().includes(term) ||
      country.value.includes(term)
    );
  }
}